<div class="field-wrapper" [ngStyle]="fieldStyle">
  <span>
    <i class="cs-icon cs-icon-calendar-check ml-1"></i>
    {{ field?.value }}</span
  >
</div>
